import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {UserCvModel} from './models/UserCv'
import {RootState} from '../../../setup'
import {shallowEqual, useSelector} from 'react-redux'
import {generatePDF} from '../cv/components/CV';

const ProfileTeaser: React.FC = () =>  {
    const intl = useIntl()
    const cv: UserCvModel = useSelector<RootState>(({auth}) => auth.cv, shallowEqual) as UserCvModel
    const API_URL = process.env.REACT_APP_API_URL

    const [loader, setLoader] = useState({state: false, index: null})

    var total = Object.keys(cv).length
    var filled = 0
    Object.entries(cv).forEach((item)=>{
        if(item[1] !== null && item[0] !== 'related_account' && item[0] !== 'id'){
            filled++
        }
    })

    return(
        <div className='card mb-5 mb-xl-10'>
            <div className='card-body pt-9 pb-0'>
                <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                    {cv.photo ? (
                    <div className='me-7 mb-4'>
                        <div className='w-150px h-150px overflow-hidden symbol symbol-150px symbol-lg-150px symbol-fixed position-relative'>
                            <img className="h-auto img-fluid " src={API_URL + cv!.photo!} alt='profil-pic' />
                        </div>
                    </div>
                    ):(
                        <></>
                    )}
                    <div className='flex-grow-1'>
                        <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                            <div className='d-flex flex-column'>
                                <div className='d-flex align-items-center mb-2'>
                                    <div className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                                        {intl.formatMessage({id: 'EDHEC.LABEL.MYCV'})}
                                    </div>
                                </div>
                                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                                <span className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                                </span>
                                </div>
                            </div>

                            <div className='d-flex mb-4 align-items-center'>
                                {(loader.state && loader.index === cv.id) ?(
                                    <span className="text-muted me-3">Loading</span>
                                ):(
                                    <button
                                        onClick={()=> generatePDF(cv.id, cv.firstname, setLoader, cv.id)}
                                        className='btn btn-sm btn-primary me-3'
                                    >
                                        <KTSVG path='/media/icons/duotune/files/fil009.svg' className='svg-icon-1 svg-icon-primary' />
                                        {intl.formatMessage({id: 'EDHEC.BUTTON.SEEPDF'})}
                                    </button>
                                )

                                }
                                <Link to={'/profile/edit/'+ cv.id} className='btn btn-sm btn-primary me-3'>
                                    <KTSVG
                                        path='/media/icons/duotune/general/gen055.svg'
                                        className='svg-icon-1 svg-icon-primary'
                                    />
                                    {intl.formatMessage({id: 'EDHEC.BUTTON.EDIT'})}
                                </Link>
                            </div>
                        </div>
                        <div className='d-flex flex-wrap flex-sm-nowrap mb-5'>

                            <div className='d-flex flex-column w-100 me-2'>
                                <div className='d-flex flex-stack mb-2'>
                                    <span className='text-muted me-2 fs-7 fw-bold'>{intl.formatMessage({id: 'EDHEC.LABEL.CV_FULFILLED'})} {Math.round((filled/total)*100)}%</span>
                                </div>
                                <div className='progress h-6px w-100'>
                                    <div
                                        className='progress-bar bg-success'
                                        role='progressbar'
                                        style={{width: Math.round((filled/total)*100)+ '%'}}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ProfileTeaser